module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/hedge-trimming/size-1-08b82a8f8e81fa2095545da1ca2b8862.svg";